import { PropTypes } from 'prop-types';
import React from 'react';

import style from './Button.module.scss';

const buttonDisplayTypes = {
  primary: 'primary',
  secondary: 'secondary',
  disabled: 'disabled',
  flat: 'flat',
};

const buttonDisplayTypesArr = [...Object.keys(buttonDisplayTypes), ''];

const Button = ({
  displayType = null,
  fluid = false,
  withShadow = false,
  withBorder = false,
  narrow = false,
  children = null,
  newVersion = false,
  customClassNames = null,
  disabled = false,
  type = 'button',
  ...btnProps
}) => {
  const className = 'c-Button';
  const classNames = [
    className,
    style[className],
    displayType ? style[`${className}--${displayType}`] : '',
    displayType ? `${className}--${displayType}` : '',
    fluid ? style[`${className}--fluid`] : '',
    withShadow ? style[`${className}--shadow`] : '',
    narrow ? style[`${className}--narrow`] : '',
    newVersion ? style[`${className}--new-version`] : '',
    withBorder ? style[`${className}--with-border`] : '',
    customClassNames ? customClassNames : '',
    disabled ? style[`${className}--disabled`] : '',
  ].join(' ');

  return (
    <button
      className={classNames}
      disabled={disabled}
      {...btnProps}
      type={type}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  fluid: PropTypes.bool,
  displayType: PropTypes.oneOf(buttonDisplayTypesArr),
  withShadow: PropTypes.bool,
  narrow: PropTypes.bool,
  newVersion: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default Button;
